export default __webpack_public_path__ + "static/compareItemImg5-8b14fdc439b69c8dfd7af876e4adc8a8.png";